import information from './information.json';
import steps from './steps.json';

export default {
  'more-investment-alternatives': {
    ...information,
    ...steps,
  },
};
